<template>
  <div class="updateExamInfo">
    <el-row type="flex" class="dialogTitle" justify="space-between">
      <el-col>
        <el-input
          v-model="query.query"
          size="small"
          placeholder="请输入学生姓名/准考证号码"
        ></el-input>
      </el-col>
      <el-col :offset="1">
        <Debounce>
          <el-button size="small" type="primary" @click="selectBut"
            >查询</el-button
          >
        </Debounce>
      </el-col>
    </el-row>
    <div style="padding: 10px 20px">
      <el-table
          :data="tableList"
          tooltip-effect="dark"
          border
          ref="elTable"
          v-loading="tableIsLoad"
          element-loading-text="加载中"
          :max-height="400"
      >
        <el-table-column
            prop="name"
            label="姓名"
            align="center"
            width="100"
        ></el-table-column>
        <el-table-column
            label="性别"
            prop="sex_dictText"
            width="80"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="subjectName"
            label="考试科目"
            show-overflow-tooltip
            align="center"
        ></el-table-column>
        <el-table-column
            width="80"
            prop="subjectLevel_dictText"
            label="报考等级"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="score"
            width="140"
            label="成绩分数"
            align="center"
        >
          <template slot-scope="{row}">
            <div>
              <el-input-number style="width: 100%" v-model="row.score" controls-position="right" :min="0" ></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="成绩等级" width="100" align="center">
          <template slot-scope="{row}">
          <span :style="{
              color: getTextAndColor(row.score).color
            }">{{getTextAndColor(row.score).text}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-row type="flex" class="dailogButBox" justify="center">
      <el-button size="medium" @click="$emit('reLoad')">取消</el-button>
      <Debounce>
        <el-button size="medium" type="primary" @click="submit">保存</el-button>
      </Debounce>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    getTextAndColor(val){
      let text = '',
          color = '';
      if(val<60){
        text = '不合格';
        color = '#f56c6c'
      }
      else if(val>59 && val<90) {
        text = '合格';
        color = '#66CC66'
      }
      else {
        text = '优秀';
        color = '#409eff'
      }
      return {
        text,
        color,
      }
    },
    selectBut() {
      this.tableIsLoad = true;
      this.$axios
        .post("score/select", this.query)
        .then((res) => {
          this.tableList = res.data.data;
          this.tableIsLoad = false;
        })
        .catch((err) => {
          this.tableIsLoad = false;
        });
    },
    submit() {
      if (this.tableList.length == 0) {
        this.$message({ type: "warning", message: "无数据保存!" ,duration:1000});
        return;
      }
      let submitList = this.tableList.map((item) => {
        return {
          id: item.id,
          score: item.score,
        };
      });
      this.$axios.post("score/update", submitList).then((res) => {
        this.$emit("reLoad");
        this.$message({ type: "success", message: "保存成功!" ,duration:1000});
      });
    },
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: false,
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
      },
    };
  },
};
</script>
<style lang="scss" scoped>
  .updateExamInfo {
    width: 100%;
    .dialogTitle{
      padding: 10px 20px;
    }
  }
  .el-table__header-wrapper {
    table {
      border-collapse: collapse;
    }
  }
</style>
